import React from 'react';
import { DimensionUnit } from '../../enums/dimension-unit';
import { WeightUnit } from '../../enums/weight-unit';
import { UnitConversionService } from '../../services/unit-conversion-service';
import { DimensionFormattedMessage } from './dimension-formatted-message';
import { WeightFormattedMessage } from './weight-formatted-message';

import { UNIT_CENTIMETER } from './intl-unit-formatting-service';

class IntlMetricUnitFormattingServiceClass {
  formatWeight({ value, unit }) {
    const valueInGrams = UnitConversionService.convertValue(value, unit, WeightUnit.Grams);
    if (Number.isNaN(valueInGrams) || valueInGrams === undefined || valueInGrams === null) {
      return '';
    }

    return <WeightFormattedMessage weight={valueInGrams} />;
  }

  formatDimensions({ length, width, height, unit }) {
    const lengthInCm = length ? UnitConversionService.convertValue(length, unit, DimensionUnit.Centimeters) : 0;
    const widthInCm = width ? UnitConversionService.convertValue(width, unit, DimensionUnit.Centimeters) : 0;
    const heightInCm = height ? UnitConversionService.convertValue(height, unit, DimensionUnit.Centimeters) : 0;

    return <DimensionFormattedMessage height={heightInCm} length={lengthInCm} unit={UNIT_CENTIMETER} width={widthInCm} />;
  }
}

export const IntlMetricUnitFormattingService = new IntlMetricUnitFormattingServiceClass();
